import {of, throwError} from 'rxjs';
import {fromPromise} from 'rxjs/internal-compatibility';
import {catchError, map, retryWhen, switchMap} from 'rxjs/operators';
import {BI_ERRORS} from '../biErrorLogger/biErrors';
import {errorLogger} from '../errorLogger/errorLogger';
import {delay} from '../utils';
import {normalizeDownloadLinks} from '../utils/normalizeDownloadLinks/normalizeDownloadLinks';
import {genericRetryStrategy} from '../utils/rxjs/genericRetryStrategy/genericRetryStrategy';
import {fetchDgs} from './fetchDgs';
import {createHttpClient} from '@wix/http-client';

export function getDownloadLinksBySnapshotId({snapshotId, instance}) {
  const makeRequest = () =>
    createHttpClient().get(`https://dgs.wixapps.net/music/cashier/order/${snapshotId}/links`, {params: {instance}});
  return makeRequest()
    .catch(() =>
      delay(2000)
        .then(makeRequest)
        .catch(() => delay(10000).then(makeRequest)),
    )
    .catch(errorLogger.createLoggingCatcher({bi: BI_ERRORS.getWindow.dgs.downloadLinksBySnapshot}))
    .then(resp => normalizeDownloadLinks(resp.data));
}

export function getDownloadLinksBySnapshotIdObserver({...params}: {snapshotId: string; instance: string}) {
  return of(params).pipe(
    switchMap(({snapshotId, instance}) => {
      const request = fetchDgs({
        url: `https://dgs.wixapps.net/music/cashier/order/${snapshotId}/links`,
        params: {instance},
      });
      return fromPromise(request);
    }),
    retryWhen(genericRetryStrategy({maxRetryAttempts: Number.MAX_SAFE_INTEGER})),
    map(resp => normalizeDownloadLinks(resp.data)),
    catchError(reason => {
      errorLogger.logError({bi: BI_ERRORS.getWindow.dgs.downloadLinksBySnapshot}, {reason});
      return throwError(reason);
    }),
  );
}
